<template>
  <v-card>
    <v-card-title>
      Doplňkové služby
    </v-card-title>
    <v-card-actions>
      <add-additional-service-dialog @update="createAdditionalService">
        <template #default="{on, attrs}">
          <v-btn outlined
                 small
                 color="primary"
                 v-on="on"
                 class="mx-1"
                 v-bind="attrs">PŘIDAT SLUŽBU</v-btn>
        </template>
      </add-additional-service-dialog>
      <v-btn small color="secondary" :disabled="selectedServices.length === 0" outlined @click="removeAdditionalService">ODSTRANIT SLUŽBU</v-btn>
    </v-card-actions>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  mobile-breakpoint="-1"
                  show-select
                  single-select
                  v-model="selectedServices"
                  @click:row="openAdditionalService"
                  item-key="_id"
    >
      <template v-slot:item.serviceTypeName="{item}">
        {{ getServiceTypeName(item.serviceTypeId) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>

import {generateRequestParams} from '@/helper/global-helper'
import AddAdditionalServiceDialog from "@/components/app/additional-services/AddAdditionalServiceDialog.vue";
import AddPartnerDialog from "@/components/app/partners/AddPartnerDialog.vue";
export default {
  components: {
    AddPartnerDialog,
    AddAdditionalServiceDialog
  },
  name: "AdditionalServicesTable",
  data() {
    return {
      headers: [
        {text: 'Název', value: 'name', sortable: false},
        {text: 'Typ služby', value: 'serviceTypeName', sortable: false},
        {text: 'Trvání (min)', value: 'duration', sortable: false},
        {text: 'Fixní cena', value: 'fixedPrice', sortable: false},
        {text: 'Podíl poskytovatele (%)', value: 'providerPercentualShare', sortable: false},
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50]
      },
      data: null,
      serviceTypes: [],
      search: null,
      selectedServices: []
    }
  },
  mounted() {
    this.getData()
    this.getServiceTypes()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.total
    },
    items() {
      if (!this.data) return []
      return this.data.data
    }
  },
  methods: {
    getData() {
      let params= generateRequestParams(
          this.options.itemsPerPage * (this.options.page - 1),
          this.options.itemsPerPage,
          null,
          this.options.sortDesc[this.options.sortBy.indexOf("createdAt")] ? "asc" : "desc"
      )
      this.axios.get('v1/additional-services', {
        params
      })
          .then(({data}) => {
            this.data = data
          })
    },
    createAdditionalService(data){
      this.getData()
    },
    openAdditionalService({ _id }) {
      this.$router.push('/app/additional-services/' + _id)
    },
    removeAdditionalService(){
      const serviceId = this.selectedServices[0]._id
      this.axios.delete(`/v1/additional-services/${serviceId}`).then((data)=>{
        this.data.data = this.data.data.filter(item => item._id !== serviceId)
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně odstránen"
        })
      })
    },
    getServiceTypes() {
      this.axios.get('v1/service-types', { params: { limit: 50 } })
        .then(({data}) => {
          this.serviceTypes = data.data || []
        })
    },
    getServiceTypeName(serviceTypeId) {
      const serviceType = this.serviceTypes.find(st => st._id === serviceTypeId)
      if (!serviceType) return '-'
      return this.translateServiceType(serviceType.serviceName)
    },
    translateServiceType(serviceName) {
      const translations = {
        'cleaning': 'Úklid',
        'general_cleaning': 'Generální úklid',
        'carpet_beating': 'Tepování',
      }
      return translations[serviceName] || serviceName
    },
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
.active{
  color: green;
}
.inactive{
  color: red;
}
</style>
